import Guard from '@/services/middleware'

const GroupHome = () => import('@/views/dash/settings/groups/GroupHome.vue')
const AuditHome = () => import('@/views/dash/settings/internalChat/audit/AuditHome.vue')

export default [
    {
        path: '/auditoria',
        name: 'internal.chat.audit',
        component: AuditHome,
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
        meta: { title: 'Auditoria chat interno', permission: 2, middleware: 'internal_chat_audit' },
    },
    {
        path: '/grupos',
        name: 'internal.chat.group',
        component: GroupHome,
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
        meta: { title: 'Grupos', permission: 2, middleware: 'internal_chat_manager' },
    },
]